import { useState, useEffect } from "react";
import Layout from "../layouts/LayoutDefault.jsx";

import MakeGetRequest from "../components/utils/MakeGetRequest.jsx";
import WelcomeHero from "../components/start_page/WelcomeHero.jsx";
import ListBlogpostsSection from "../components/ListBlogpostsSection.jsx";
import ListBandsSection from "../components/ListBandsSection.jsx";
import ListEventsSection from "../components/ListEventsSection.jsx";
import CommercialBanner from "../components/CommercialBanner.jsx";
import CallToActionBanner from "../components/start_page/CallToActionBanner.jsx";
import PollSection from "../components/PollSection.jsx";

const Home = () => {
  const [showLoading, setShowLoading] = useState(false);
  const { data: data } = MakeGetRequest({
    route: `home`,
  });
  const { data: eventsData } = MakeGetRequest({
    route: `get_events?page=1&limit=6`,
  });
  const upcomingEvents = eventsData?.items || [];

  // Only show loading message after 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!data) {
        setShowLoading(true);
      }
    }, 2000);

    // Clear timer if data loads before 2 seconds
    if (data) {
      clearTimeout(timer);
    }

    return () => clearTimeout(timer);
  }, [data]);

  const seoTitle = "Lokult - All musik från Strängnäs kommun på ett ställe";
  const seoDescription =
    "Upptäck musik från Strängnäs eller dela med dig av din egen. Rock, pop eller dansband - Nytt som gammalt du hittar det på lokult";

  if (data) {
    return (
      <>
        <Layout title={seoTitle} description={seoDescription}>
          <WelcomeHero spotlight={data.spotlight} />
          <CallToActionBanner />
          <div className="z-1 mb-20">
            <ListBandsSection
              listName="Nytt i Strängnäs"
              underText="De nyaste banden och artisterna här"
              bands={data.new_bands}
            />
            <CommercialBanner />

            {upcomingEvents.length > 0 && (
              <ListEventsSection
                listName="Evenemang"
                underText="Kommande musikevenemang i Strängnäs kommun"
                items={upcomingEvents}
              />
            )}

            <PollSection />

            <ListBlogpostsSection
              listName="Nyheter & Blogginlägg"
              subtitle="De senaste nyheterna och blogginläggen"
              newsItems={data.newsposts}
              blogItems={data.blogposts}
            />
          </div>
        </Layout>
      </>
    );
  } else if (showLoading) {
    return (
      <Layout>
        <div className="text-center my-20">
          <h1 className="text-2xl font-bold">Laddar...</h1>
          <p>Vänligen vänta medan sidan laddas.</p>
          <p>Du kan försöka ladda om sidan.</p>
          <p>Om problemet kvarstår, då har vi ett problem :´(</p>
        </div>
      </Layout>
    );
  } else {
    // Show nothing while waiting for the 2-second delay
    return null;
  }
};

export default Home;
